import React from 'react'
import '../components/EnvironBan.css'

import SOLARPLANT from "../images/videos/VIDEOS/VID6.mp4";

export default function EnvironBan() {

  const handleWhatsApp = () => {
    const phone = "919597839564";
    const message = encodeURIComponent(
      "Hello RAD EnviroNex Team 👋\n\n" +
      "I am interested in conducting a professional *Environmental Audit* for our organization. " +
      "We are looking to assess our environmental performance, waste management, and regulatory compliance status.\n\n" +
      "Kindly let us know the audit framework you follow and the next steps to schedule an assessment.\n\n" +
      "Looking forward to your expert support!"
    );

    window.open(`https://wa.me/${phone}?text=${message}`, "_blank");
  };


  return (
    <>





      <section className="hero">
        {/* VIDEO */}
        <video
          className="hero-video"
          src={SOLARPLANT}
          autoPlay
          loop
          muted
          playsInline
        />

        {/* OVERLAY */}
        <div className="hero-overlay"></div>

        {/* CONTENT */}
        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>ENVIRONMENTAL AUDIT </h1>
            <p>Power Your Future with the Sun</p>

            <button className="quote-btn" onClick={handleWhatsApp}>
              Get Quote
            </button>
          </div>
        </div>
      </section>





    </>
  )
}
